import * as React from "react";

const CameraIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 12 12"
  >
    <path
      fill="#1A64B9"
      d="M10.565 2.869H9.313l-.691-1.044A1.44 1.44 0 0 0 7.435 1.2h-2.87c-.47 0-.926.235-1.187.626L2.687 2.87H1.435A1.43 1.43 0 0 0 0 4.304v5.06C0 10.16.64 10.8 1.435 10.8h9.13A1.43 1.43 0 0 0 12 9.364v-5.06a1.43 1.43 0 0 0-1.435-1.435M6 9.625a3.234 3.234 0 0 1-3.235-3.234A3.223 3.223 0 0 1 6 3.169a3.234 3.234 0 0 1 3.235 3.235A3.23 3.23 0 0 1 6 9.625m4.383-4.734h-.574a.423.423 0 0 1 0-.848h.521c.235-.013.43.17.444.404a.413.413 0 0 1-.391.444"
    ></path>
    <path
      fill="#1A64B9"
      d="M6 4.604c-.991 0-1.8.808-1.8 1.8 0 .99.809 1.786 1.8 1.786.992 0 1.8-.808 1.8-1.8 0-.99-.808-1.786-1.8-1.786"
    ></path>
  </svg>
);

export default CameraIcon;
